import { LANGUAGE_FLAG, LANGUAGE_NAMES, countryName, isLanguage } from './places'
import './Flag.css'

/**
 * A country's flag, as a picture — 28 Oct 2026.
 *
 * Pictures rather than emoji: Windows draws a flag emoji as two letters, so
 * on most of the team's machines "🇳🇴" reads as "NO". The SVGs are the
 * `country-flag-icons` set (MIT), emitted as files of our own rather than
 * inlined, so a page loads only the flags it shows.
 */
const URLS = import.meta.glob('/node_modules/country-flag-icons/3x2/*.svg', {
  query: '?no-inline',
  import: 'default',
  eager: true,
}) as Record<string, string>

const urlOf = (code: string): string | undefined =>
  URLS[`/node_modules/country-flag-icons/3x2/${code.toUpperCase()}.svg`]

/** The flag of an ISO country code, with the name on hover. */
export function Flag({ code, title }: { code: string | null | undefined; title?: string }) {
  if (!code) return <span className="cflag cflag--none">—</span>
  const url = urlOf(code)
  const name = title ?? countryName(code)
  if (!url) return <span className="cflag cflag--text" title={name}>{code.toUpperCase()}</span>
  return <img className="cflag" src={url} alt={code.toUpperCase()} title={name} width={21} height={14} />
}

/** A language as the flag it is shown with: Norwegian, Norway's; English, Britain's. */
export function LanguageFlag({ language }: { language: string | null | undefined }) {
  if (!isLanguage(language)) return <span className="cflag cflag--none">—</span>
  return <Flag code={LANGUAGE_FLAG[language]} title={LANGUAGE_NAMES[language]} />
}
